






















































import { Vue, Component, Prop, Watch, Emit } from 'vue-property-decorator';

const sha1 = require('crypto-js/sha1');

// const bcrypt = require('bcrypt');

@Component
export default class Home extends Vue {
  passwordRegex: RegExp = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[A-Za-z\d!"#$%&'()*+,-./:;<=>?@[\]^_`{|}~]{8,}$/;

  login: string = '';

  oldPassword: string = '';

  newPassword: string = '';

  newPasswordValidation: string = '';

  error: boolean = false;

  errorMessage: string = '';

  loginError: boolean = false;

  oldPasswordError: boolean = false;

  newPasswordError: boolean = false;

  get compWrongNewPassword(): string {
    return this.newPasswordError && this.error ? 'login-form-wrong-credentials' : '';
  }

  get compWrongOldPassword(): string {
    return this.oldPasswordError && this.error ? 'login-form-wrong-credentials' : '';
  }

  get compWrongLogin(): string {
    return this.loginError && this.error ? 'login-form-wrong-credentials' : '';
  }

  get compConnectedButton(): boolean {
    return this.login === '' || this.oldPassword === '' || this.newPassword === '' || this.newPasswordValidation === '';
  }

  async digestPassword(password: string): Promise<any> {
    return sha1(password).toString();
  }

  async checkCredentials(): Promise<any> {
    const oldPassword = await this.digestPassword(this.oldPassword);
    const password = await this.digestPassword(this.newPassword);

    if (this.newPassword !== this.newPasswordValidation) {
      this.error = true;
      this.errorMessage = 'Les mot de passe ne correspondent pas';
      this.newPasswordError = true;
      return;
    } else if (!this.passwordRegex.test(this.newPassword)){
      this.error = true;
      this.errorMessage = 'Votre mot de passe ne rempli pas les critères';
      this.newPasswordError = true;
      return;
    }

    await this.$store
      .dispatch('login/a_post_changePassword', { login: this.login, oldPassword, newPassword: this.newPassword })
      .then(() => {
        this.$store
          .dispatch('login/a_post_login', { login: this.login, password })
          .then(() => {
            this.$router.push('/dashboard');
          })
          .catch((err) => {
            this.$router.push('/login');
          });
      })
      .catch((err) => {
        if (err.response.status === 461) {
          this.loginError = true;
          this.error = true;
          this.errorMessage = 'Aucun compte avec cette adresse email';
        } else if (err.response.status === 462) {
          this.oldPasswordError = true;
          this.error = true;
          this.errorMessage = 'L\'ancien mot de passe est faux';
        }
      });
  }

  onInputFocus(): void {
    this.error = false;
    this.errorMessage = '';
    this.newPasswordError = false;
    this.oldPasswordError = false;
    this.loginError = false;
  }
}
